module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero docs-improve-this"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": ("https://github.com/buefy/buefy/blob/dev/docs/" + _vm.githubPath),
      "target": "_blank"
    }
  }, [_vm._v("\n                    Improve this page on GitHub\n                ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-grey"
  }, [_vm._v("\n                This page is "), _c('strong', {
    staticClass: "has-text-grey-dark"
  }, [_vm._v("open source")]), _vm._v(".\n                Noticed a typo or something's unclear?\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c2eb8ee"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/components/ImproveThis.vue
// module id = 1602
// module chunks = 300